var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning Light",
    clipPath: "url(#clip0_1167_2328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 14C8.8565 14 10.6368 13.2624 11.9499 11.9499C13.2624 10.6368 14 8.8565 14 7C14 5.1435 13.2624 3.36321 11.9499 2.05008C10.6368 0.737561 8.8565 0 7 0C5.1435 0 3.36321 0.737624 2.05008 2.05008C0.737561 3.36322 0 5.1435 0 7C0.00247528 8.85586 0.740112 10.6349 2.05262 11.9474C3.36514 13.2599 5.1443 13.9975 7 14ZM7 1.15518C8.55015 1.15518 10.0372 1.7709 11.1331 2.86688C12.229 3.96282 12.8448 5.44988 12.8448 7C12.8448 8.55012 12.2291 10.0372 11.1331 11.1331C10.0372 12.229 8.55012 12.8448 7 12.8448C5.44988 12.8448 3.96282 12.2291 2.86688 11.1331C1.77095 10.0372 1.15518 8.55012 1.15518 7C1.15642 5.45049 1.77337 3.96472 2.86863 2.86879C3.96456 1.77347 5.45036 1.15645 6.99984 1.15534L7 1.15518ZM7.57735 8.45047L6.42201 8.45047L6.42263 3.43861H7.57797L7.57735 8.45047ZM7.57735 10.5612L6.42201 10.5612L6.42263 9.39413L7.57797 9.39413L7.57735 10.5612Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_2328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaringIcon);
export default __webpack_public_path__ + "static/media/waring_icon.036db34a1c28df0e6cb88a6363c47a07.svg";
export { ForwardRef as ReactComponent };